import { styled } from 'baseui';

export const LabelRequiredDotError = styled('span', () => {
	return {
		width: '1em',
		textAlign: 'center',
		color: 'var(--epods--color-text-primary)',
		display: 'inline-block',
	};
});

export const LabelRequiredDot = styled('span', () => {
	return {
		width: '1em',
		textAlign: 'center',
		color: 'var(--epods--color-text-primary)',
		display: 'inline-block',
	};
});

export const LabelBase = ($disabled: boolean, $error: boolean, $positive: boolean, size: string) => {
	const _size = size || 'default';
	const fontDef = {
		fontSize: 'var(--epods--fcontrol-' + _size + '-label-font-size)',
		lineHeight: 'var(--epods--fcontrol-' + _size + '-label-line-height-size)',
		fontFamily: 'var(--epods--font-secondary-semibold)',
	};
	return {
		...fontDef,
		color: $disabled ? 'var(--epods--color-text-disabled)' : 'var(--epods--color-text-primary)',
	};
};

export const CaptionBase = (
	$disabled: boolean,
	$error: boolean,
	$positive: boolean,
	size: string,
	warning: boolean,
	isOverlay: boolean,
	overlayCaptionMinWidth: string,
	overlayCaptionMaxWidth: string,
) => {
	const statusColor = $error
		? 'var(--epods--color-signal-error-text)'
		: $positive
		? 'var(--epods--color-signal-success-text)'
		: warning
		? 'var(--epods--color-signal-warning-text)'
		: 'var(--epods--color-text-primary) ';
	const _size = size ? size : isOverlay ? 'large' : 'default';
	const fontDef = {
		fontSize: isOverlay
			? 'var(--epods--fcontrol-overlay-caption-font-size)'
			: 'var(--epods--fcontrol-' + _size + '-caption-font-size)',
		lineHeight: 'var(--epods--fcontrol-' + _size + '-caption-line-height-size)',
		fontFamily: 'var(--epods--font-secondary)',
	};
	const minWidth = overlayCaptionMinWidth ? overlayCaptionMinWidth : '100%';
	const overlayStyling = isOverlay
		? {
				boxShadow: '0px 4px 8px rgba(94, 124, 143, 0.3)',
				borderRadius: 'var(--epods--border-radius)',
				paddingTop: 'var(--epods--space-inset-s2)',
				paddingRight: 'var(--epods--space-inset-s)',
				paddingBottom: 'var(--epods--space-inset-s2)',
				paddingLeft: 'var(--epods--space-inset-s)',
				zIndex: 'var(--epods--zindex-dropdown)',
				border: '1px solid var(--epods--color-bluegrey-100)',
				backgroundColor: 'var(--epods--color-bg)',
				display: 'block',
				position: 'absolute',
				width: 'max-content',
				minWidth: `${minWidth}`,
				maxWidth: `${overlayCaptionMaxWidth}`,
				overflowWrap: 'anywhere',
		  }
		: {};
	return {
		//fontFamily: $theme.typography.fontBaseP.fontFamily,
		...fontDef,
		// TODO: lineHeight: $theme.typography.fontBaseP.lineHeight,
		color: $disabled ? 'var(--epods--color-text-disabled)' : statusColor,
		...overlayStyling,
	};
};
